/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Disease
 */
export interface Disease {
    /**
     * 
     * @type {string}
     * @memberof Disease
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Disease
     */
    acronym: string;
    /**
     * 
     * @type {string}
     * @memberof Disease
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Disease
     */
    texts: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Disease
     */
    publications: Array<string>;
}

/**
 * Check if a given object implements the Disease interface.
 */
export function instanceOfDisease(value: object): value is Disease {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('acronym' in value) || value['acronym'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('texts' in value) || value['texts'] === undefined) return false;
    if (!('publications' in value) || value['publications'] === undefined) return false;
    return true;
}

export function DiseaseFromJSON(json: any): Disease {
    return DiseaseFromJSONTyped(json, false);
}

export function DiseaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): Disease {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'acronym': json['acronym'],
        'description': json['description'],
        'texts': json['texts'],
        'publications': json['publications'],
    };
}

export function DiseaseToJSON(json: any): Disease {
    return DiseaseToJSONTyped(json, false);
}

export function DiseaseToJSONTyped(value?: Disease | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'acronym': value['acronym'],
        'description': value['description'],
        'texts': value['texts'],
        'publications': value['publications'],
    };
}

